import { render, staticRenderFns } from "./CollapsibleRichTextNote.vue?vue&type=template&id=2f8c4f63&scoped=true"
import script from "./CollapsibleRichTextNote.vue?vue&type=script&lang=js"
export * from "./CollapsibleRichTextNote.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleRichTextNote.vue?vue&type=style&index=0&id=2f8c4f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c4f63",
  null
  
)

export default component.exports